import { Grid, Box } from '@mui/material';
import React from 'react';
import Research from '../../../shared/Research/Research';
import Section from '../../../shared/Section/Section';
import Statistic from '../../../shared/Statistic/Statistic';

function Employment({ title, subtitle, data }) {
  return (
    <Section
      subtitle={subtitle}
      title={title}
      theme="light"
      size="small"
      bg="employment"
      position="bottom"
      anchor="work"
    >
      <Grid container>
        <Grid item xs={12} xl={9}>
          <Box
            sx={{
              flexGrow: 1,
              paddingBottom: {
                xs: '40px',
                xl: '48px',
              },
            }}
          >
            <Statistic statistic={data.statistic} />
          </Box>

          <Research {...data.research} />
        </Grid>
      </Grid>
    </Section>
  );
}

export default Employment;
